<app-gallery-multiselect-toolbar
  [visible]="isMultiSelectMode"
  (toggleWebsiteForSelected)="toggleWebsiteForSelected()"
  (toggleSharepointForSelected)="toggleSharepointForSelected()"
  (downloadSelected)="downloadSelectedMedia()"
  (deleteSelected)="deleteSelectedMedia()"
  (cancelSelection)="multiSelectMode()"
/>

<app-gallery-header
  [animal]="animal"
  [filter]="filter"
  [mediaCategoryOptions]="mediaCategoryOptions"
  (multiSelectToggle)="multiSelectMode()"
  (filterChange)="onFilterChange()"
  [media]="media"
  [isMultiSelectMode]="isMultiSelectMode"
/>

<app-gallery-grid
  [animal]="animal"
  [media]="filteredMedia"
  [flippedItems]="flippedItems"
  [isMultiSelectMode]="isMultiSelectMode"
  [selectedIds]="selectedMediaIds"
  [mediaCategoryOptions]="mediaCategoryOptions"
  (toggleSelect)="toggleSelect($event)"
  (toggleFlip)="toggleFlip($event.id, $event.event)"
  (toggleSharedFolder)="toggleSharedFolder($event)"
  (toggleWebsite)="toggleWebsite($event)"
  (togglePreview)="togglePreview($event)"
  (categoryChange)="onCategoryChange($event)"
  (deleteMedia)="deleteMedia($event)"
  (downloadMedia)="downloadSingleMedia($event)"
  (dateChange)="onDateChange($event)"
/>
